import {
  ChangeDetectorRef,
  Component,
  Inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import { NavigationService } from '../../services/util/navigation.service';
import { InquiryOpen } from '../../model/inquiry/InquiryOpen';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DateRangeComponent } from '../../scheduling/date-range/date-range.component';

@Component({
  selector: 'app-join-open-appointment-dialog-dialog',
  imports: [
    MatButton,
    MatIcon,
    MatDialogTitle,
    MatDialogContent,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    DateRangeComponent,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatDialogActions,
    MatDialogClose,
  ],
  templateUrl: './join-open-appointment-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./join-open-appointment-dialog.component.scss'],
})
export class JoinOpenAppointmentDialogComponent {
  protected dataSource = new MatTableDataSource<InquiryOpen>([]);

  protected displayedColumns: string[] = [
    'title',
    'name',
    'scheduledFor',
    'assignedEmployeeDisplayName',
    'joinAppointment',
  ];

  constructor(
    private readonly navigationService: NavigationService,
    private readonly dialogRef: MatDialogRef<JoinOpenAppointmentDialogComponent>,
    private readonly cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) data: { inquiries: InquiryOpen[] },
  ) {
    this.dataSource.data = [...data.inquiries];
    this.cdr.markForCheck();
  }

  onJoinAppointmentClicked(inquiry: InquiryOpen) {
    if (!inquiry.inquiryIdentifier) return;
    this.navigationService.navigateToVideoAppointment(
      inquiry.inquiryIdentifier,
      true,
      inquiry.videoAppointmentIdentifier,
    );
    this.dialogRef.close();
  }

  protected getCaseTitle(inquiry: InquiryOpen): string {
    const title = inquiry.title?.trim();
    if (title) {
      return title;
    }

    if (inquiry.inquiryCreatedAt) {
      const createdAt = new Date(inquiry.inquiryCreatedAt);
      if (!Number.isNaN(createdAt.getTime())) {
        return (
          $localize`:@@joinOpenAppointmentDefaultCaseTitle:Fall vom ` +
          createdAt.toLocaleDateString()
        );
      }
    }

    return $localize`:@@joinOpenAppointmentNoCaseTitle:Kein Falltitel angegeben`;
  }
}
